// Author XXL
// Date 2020-10-27 10:11:55

class SithMesQualityKpiPassRate {
constructor({
        id = null,
        kprYear = '',
        mstLocationId = '',
        mstLocationName = '',
        departmentNameAbbr = '',
        passRate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.kprYear = kprYear;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.departmentNameAbbr = departmentNameAbbr;
    this.passRate = passRate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesQualityKpiPassRate();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'kprYear',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.grid.kprYear',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationId',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.grid.mstLocationId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'departmentNameAbbr',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.grid.departmentNameAbbr',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'passRate',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.grid.passRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    kprYearFilter : "",
    mstLocationIdFilter : "",
    departmentNameAbbrFilter : "",
    passRateFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'kprYearFilter',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.filter.kprYear',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'departmentNameAbbrFilter',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.filter.departmentNameAbbr',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'passRateFilter',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.filter.passRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'kprYear',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.entity.kprYear',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.entity.mstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'departmentNameAbbr',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.entity.departmentNameAbbr',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'passRate',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.entity.passRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityKpiPassRate.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesQualityKpiPassRate, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
